/* import __COLOCATED_TEMPLATE__ from './post.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./post.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());